<template lang="pug">
  div
    div.label.basic600--text.text-uppercase Date
    v-divider.basic300.my-3
    v-row(no-gutters)
      v-col.pb-2.pr-2.shrink(v-for="range in ranges" :key="range.value")
        v-chip.button-AA-tiny.text-uppercase.px-3(:key="range.value" label small :outlined="selectedRange.value === range.value" :color="selectedRange.value === range.value ? 'info500' : 'basic300'" :style="selectedRange.value === range.value ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" @click="selectRange(range)") {{ range.name }}
    div.c1.primary--text.mt-2(v-if="selectedRange.dates && selectedRange.dates.length > 0") Date range:
      span.ml-1.info500--text {{ selectedRange.dates[0] | displayDate }} - {{ selectedRange.dates[1] | displayDate }}

    .modal
      date-picker-order(v-if="datePickerOrderDialog" :open.sync="datePickerOrderDialog" @selected="dateRangeSelected($event)" @cancel="selectAll")
</template>

<script>
import { DateTime } from 'luxon'
import DatePickerOrder from '@/components/dialogs/order/DatePickerOrder.vue'

export default {
  name: 'PayoutDate',
  components: { DatePickerOrder },
  props: {
    parentRange: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data: () => ({
    datePickerOrderDialog: false,
    ranges: [
      { name: 'All', value: null, dates: null },
      { name: 'Today', value: 'today', dates: null },
      { name: 'Yesterday', value: 'yesterday', dates: null },
      { name: 'Past 7 days', value: 'week', dates: null },
      { name: 'This month', value: 'month', dates: null },
      { name: 'This year', value: 'year', dates: null },
      { name: 'Custom dates', value: 'custom', dates: null }
    ]
  }),
  computed: {
    selectedRange: {
      get () {
        return this.parentRange
      },
      set (newValue) {
        this.$emit('update:parentRange', newValue)
      }
    }
  },
  methods: {
    dateRangeSelected (dates) {
      const sortedDates = dates.slice().sort((a,b)=> {
        return DateTime.fromISO(a) - DateTime.fromISO(b)
      })
      this.$set(this.selectedRange, 'dates', sortedDates)
    },
    selectAll () {
      this.selectedRange = { name: 'All', value: null, date: null }
    },
    selectRange (range) {
      if (range.value === 'custom') {
        this.selectedRange = range
        this.$set(this.selectedRange, 'dates', null)
        this.datePickerOrderDialog = true
      } else {
        this.selectedRange = range
      }
    }
  }
}
</script>